import { render, staticRenderFns } from "./MarqetaFooter.vue?vue&type=template&id=727c89ce&scoped=true"
import script from "./MarqetaFooter.vue?vue&type=script&lang=js"
export * from "./MarqetaFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727c89ce",
  null
  
)

export default component.exports